import React, {useEffect, useState} from 'react'
// Components
import OptInText from '../auth/opt-in-text'
// Styles
import formStyles from './forms.module.scss'

interface InputCheckboxProps {
  id: string
  label: string
  instructions?: React.ReactNode | null
  initialValue?: boolean
  isRichText?: boolean
  // isDisabled?: boolean
  onChange?: (event: React.ChangeEvent<HTMLInputElement>, id: string) => void
}

const InputCheckbox = ({
  id,
  label,
  instructions = null,
  initialValue = false,
  isRichText = false,
  // isDisabled = false,
  onChange,
}: InputCheckboxProps) => {
  const [isChecked, setIsChecked] = useState(false)

  useEffect(() => {
    setIsChecked(Boolean(initialValue))
  }, [initialValue])

  const handleCheckboxChange = (syntheticEvent: React.ChangeEvent<HTMLInputElement>) => {
    const newIsChecked = syntheticEvent.target.checked
    setIsChecked(newIsChecked)

    if (onChange) onChange(syntheticEvent, id)
  }

  return (
    <div
      key={`field-${id}`}
      className={formStyles['__checkbox-wrapper']}
    >
      <label
        htmlFor={`field-${id}`}
        className={formStyles['__label']}
      >
        <input
          type="checkbox"
          id={`field-${id}`}
          name={`field-${id}`}
          checked={isChecked}
          onChange={handleCheckboxChange}
          className={formStyles['__field']}
        />
        {isRichText && <OptInText optInText={label} />}
        {!isRichText && label}
      </label>
      {instructions && <div className={formStyles['__instructions']}>{instructions}</div>}
    </div>
  )
}

export default InputCheckbox
